// extracted by mini-css-extract-plugin
export default {"body":"Entry_body__ds1RC","wrap":"Entry_wrap__XCbWB","button":"Entry_button__v+KPr","field":"Entry_field__ke0fM"};